import { ActionCreatorAbstract } from '../../core/classes/action-creator.abstract';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { WorkflowConfigService } from '../services/workflow-config.service';
import { getActiveRecord } from '../utils/store.utils';

export abstract class WorkflowDrivenActionCreatorAbstract<Type> extends ActionCreatorAbstract<Type> {

  protected constructor(store: Store<any>, pathsOrSelectors: Array< string | any >, protected workflowConfigService: WorkflowConfigService) {
    super(store, ...pathsOrSelectors);
  }

  handleStateValue(props: Array<string>, value: any): Promise<any> | Observable<any> {
    return getActiveRecord(value, null, null);
  }

  public getActiveCacheKey(): Observable<string> {
    return this.workflowConfigService.getCacheKey();
  }


}


